namespace RedBullMOBILE360.Sms {
    export interface CampaignEligibilityForm {
        OfferId: Serenity.StringEditor;
        WhitelistId: Serenity.IntegerEditor;
    }

    export class CampaignEligibilityForm extends Serenity.PrefixedContext {
        static formKey = 'Sms.CampaignEligibility';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CampaignEligibilityForm.init)  {
                CampaignEligibilityForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(CampaignEligibilityForm, [
                    'OfferId', w0,
                    'WhitelistId', w1
                ]);
            }
        }
    }
}
